import type { PageSection } from '@cng/shared';
import { useSite } from '@/app/page-data';
import { LocationsSection } from '@/components/locations/LocationsSection';

/**
 * Renders the "Find Us" block a CMS page carries.
 *
 * Every page on the live site closes with it, so the price menus, the gallery
 * and the contact page all reach for this rather than repeating the wiring.
 * Hiding it is a matter of disabling the section in admin, not editing code.
 */
export function PageBranches({ sections }: { sections: PageSection[] }) {
  const { settings, branches } = useSite();
  const section = sections.find((s) => s.type === 'branches' && s.enabled);
  if (!section) return null;

  const d = section.data ?? {};
  const str = (key: string): string => (typeof d[key] === 'string' ? (d[key] as string) : '');

  return (
    <LocationsSection
      config={{
        enabled: true,
        tag: str('tag'),
        title: str('title'),
        titleAccent: str('titleAccent'),
        subtitle: str('subtitle'),
      }}
      branches={branches}
      settings={settings}
    />
  );
}
